import { Week } from './../../model/Week';
import { Component } from '@angular/core';
import { NavParams, /*AlertController,*/ Keyboard, ViewController } from 'ionic-angular';
import { IonicPage } from 'ionic-angular';

import { CoreProvider } from './../../providers/core-service/core-service';
import { leaveLabel } from '../../constants/constants';

/**
 * Generated class for the Weekly page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
@IonicPage()
@Component({
  selector: 'modal-edit',
  templateUrl: 'modal-edit.html'
})
export class ModalEditPage {

  private stateArray: string[] = ['Headquarter', 'Travel', 'Leave', 'Bank Holiday'];

  private selectedDays: string[] = []; //giorni da modificare
  private userKey: string = ''; //utente da modificare

  private week_data: Week;

  /*nel caso servano inserire [style.height.px]="heightAuto" */
  private heightModal = 192;
  private leaveHeight = 320;
  private travelHeight = 368;

  showPlaces = true;

  leaveLabels = leaveLabel;

  selectedState: string;
  selectedStateIndex: number; //0= Headquarter , 1 = travel, 2 = Leave, 3 = Bank Holiday

  leaveState: string;

  places: any[];
  stores: any[];
  place: string;
  notes: string;

  constructor(
    private viewCtrl: ViewController,
    private coreService: CoreProvider,
    private navParams: NavParams,
    private keyboard: Keyboard
  ) { }

  ionViewWillEnter() {

    this.leaveLabels = this.coreService.getLeaveLabel(true);
    this.selectedDays = this.navParams.get('selected');
    this.userKey = this.navParams.get('userkey');
    this.week_data = this.navParams.get('week');

    this.selectedStateIndex = -1;
    this.selectedState = '';

    this.leaveState = '';
    this.places = [];
    this.stores = [];
    this.place = '';
    this.notes = '';

    if (this.selectedDays.length == 1) {
      if (this.week_data[this.selectedDays[0]].toUpperCase() == 'Headquarter'.toUpperCase()) {
        this.selectedStateIndex = 0;
        this.selectedState = 'Headquarter';
      } else if (this.week_data[this.selectedDays[0]].toUpperCase() == 'Bank Holiday'.toUpperCase()) {
        this.selectedStateIndex = 3;
        this.selectedState = 'Bank Holiday';
      } else if (this.leaveLabels.indexOf(this.week_data[this.selectedDays[0]]) > -1) {
        this.selectedStateIndex = 2;
        this.selectedState = 'Leave';
        this.leaveState = this.week_data[this.selectedDays[0]];
      } else {
        this.selectedStateIndex = 1;
        this.place = this.week_data[this.selectedDays[0]];
        this.notes = this.week_data[this.selectedDays[0] + '_note'];
        this.selectedState = 'Travel';
      }
      //else if lancia ricera autocomplete per travel MOD
    }

  }

  /**
   * Funzione di test per rendere l'altezza del modal in base allo stato selezionato
   */
  heightAuto(): number {
    if (this.selectedStateIndex < 0)
      return this.heightModal;
    else {
      if (this.selectedStateIndex == 0 || this.selectedStateIndex == 3) {
        return this.heightModal;
      } else if (this.selectedStateIndex == 2) {
        return this.leaveHeight;
      } else if (this.selectedStateIndex == 1) {
        return this.travelHeight;
      }
    }
  }


  /**
   * Seleziona stato 
   * @param index indice nell'array stateArray
   */
  selectState(index: number) {
    this.selectedState = this.stateArray[index];
    this.selectedStateIndex = index;
  }

  /**
   * Seleziona label stato Leave
   * @param txt 
   */
  selectLeave(txt: string) {
    this.leaveState = txt;
  }

  /**
   * Funzione autocompletamento
   * @param query stringa ricercata
   * 
   */
  onChange(query: string) {
    if (query.length > 2) {
      this.coreService.getAutocompletePlacesStore(query).subscribe(result => {
        this.showPlaces = true;

        this.places = [];
        for (let place in result.places)
          this.places.push(result.places[place]);

        this.stores = [];
        for (let place in result.stores)
          this.stores.push(result.stores[place]);
      });
    } else {
      this.showPlaces = false;
    }
  }

  /**
  * Lancia autocomplete al click su input place
   */
  fireAutocomplete() {
    if (this.place.length > 2) {
      this.coreService.getAutocompletePlacesStore(this.place).first().subscribe(result => {

        if (this.place.length == 0)
          return;

        this.showPlaces = true;

        //array place ordinato stampare label property
        this.places = [];
        for (let place in result.places)
          this.places.push(result.places[place]);

        this.stores = [];
        for (let place in result.stores)
          this.stores.push(result.stores[place]);
      });
    } else {
      this.showPlaces = false;
    }
  }

  /**
   * Resetta campo ricerca
   */
  resetSearch() {
    this.place = '';

    this.places = [];
    this.stores = [];

    this.showPlaces = false;

  }

  /**
   * Inserisce il luogo nella label per stato travel
   */
  setPlace(place: string) {
    this.showPlaces = false;
    this.place = place;
  }

  submitPlace() {
    this.showPlaces = false;
    this.keyboard.close();
  }
  /**
   * Verifica che il form possa essere inviato
   */
  verifyForm(): boolean {
    if (this.selectedStateIndex < 0)
      return false;
    else {
      if (this.selectedStateIndex == 0 || this.selectedStateIndex == 3) {
        return true;
      } else if (this.selectedStateIndex == 2) {
        if (this.leaveState == '') {
          return false;
        } else {
          return true;
        }
      } else if (this.selectedStateIndex == 1) {
        if (this.place.length == 0) {
          return false;
        } else
          return true;
      }
    }
    return false;
  }

  /**
   * Chiede conferma ed invia i dati all'endpoint
   */
  saveSlots() {

    if (!this.verifyForm()) return;

    //coer service save slots
    /*let alert = this.alertCtrl.create({
      title: 'Confirm change?',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel'
        },
        {
          text: 'OK',
          handler: () => {
            console.log('clicked');
            this.viewCtrl.dismiss();
*/
    this.viewCtrl.dismiss();
    this.sendData();
    /*        }
          }
        ]
      });
      alert.present();*/

  }

  /**
   * Codifica i dati per l'endpoint
   */
  sendData() {

    let week: any = {};
    let placeOb: any = {};

    //0= Headquarter , 1 = travel, 2 = Leave, 3 = Bank Holiday
    if (this.selectedStateIndex == 0 || this.selectedStateIndex == 3) {
      for (let i of this.selectedDays) {
        week[i] = this.selectedState;
      }
    } else if (this.selectedStateIndex == 2) {
      for (let i of this.selectedDays) {
        week[i] = this.leaveState;
      }
    } else if (this.selectedStateIndex == 1) {
      for (let i of this.selectedDays) {
        week[i] = this.place;
        if (this.notes && this.notes.length > 0)
          week[i + '_note'] = this.notes;
        else
          week[i + '_note'] = "";
      }
      if (this.place) {
        for (let key of this.places) {
          if (key.label.toLowerCase() == this.place.toLowerCase()) {
            placeOb[key.label] = key;
            break;
          }
        }
        for (let key of this.stores) {
          if (key.label.toLowerCase() == this.place.toLowerCase()) {
            placeOb[key.label] = key;
            break;
          }
        }
      }
    }

    this.coreService.saveWeek(this.userKey, week, placeOb);
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/modal-edit/modal-edit.ts